import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BrandProvider } from "@/context/BrandContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Suppliers from "@/pages/Suppliers";
import Products from "@/pages/Products";
import Assets from "@/pages/Assets";
import SalesInvoices from "@/pages/SalesInvoices";
import PurchaseInvoices from "@/pages/PurchaseInvoices";
import DeliveryNotes from "@/pages/DeliveryNotes";
import Projects from "@/pages/Projects";
import Reports from "@/pages/Reports";
import BalanceSheet from "@/pages/BalanceSheet";
import Settings from "@/pages/Settings";
import PrintInvoice from "@/pages/PrintInvoice";
import PrintDN from "@/pages/PrintDN";
import PublicInvoice from "@/pages/PublicInvoice";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-forest-400">Memuat…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/public/invoice/:token" element={<PublicInvoice />} />
            <Route path="/print/invoice/:id" element={<Protected><PrintInvoice /></Protected>} />
            <Route path="/print/dn/:id" element={<Protected><PrintDN /></Protected>} />
            <Route element={<Protected><BrandProvider><Layout /></BrandProvider></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/suppliers" element={<Suppliers />} />
              <Route path="/products" element={<Products />} />
              <Route path="/assets" element={<Assets />} />
              <Route path="/sales" element={<SalesInvoices />} />
              <Route path="/purchase" element={<PurchaseInvoices />} />
              <Route path="/delivery" element={<DeliveryNotes />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/balance-sheet" element={<BalanceSheet />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
